export const model = {
    id: null,
    name: '',
    price: '',     
    created_at: '',
    updated_at: ''
};
